import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { auth, db } from '../firebase';
import { Form, Input, FormGroup, Button } from '../styles/components';
import * as routes from '../constants/routes';
const INITIAL_STATE = {
  userName: '',
  email: '',
  passwordOne: '',
  passwordTwo: '',
  error: null
};

const SignUpPage = ({ history, layoutItem: LayoutItem }) => (
  <LayoutItem style={{ maxWidth: '600px', margin: '0 auto' }}>
    <h1>Sign up Page</h1>
    <SignUpForm history={history} />
  </LayoutItem>
);

class SignUpForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  onSubmit(event) {
    event.preventDefault();
    const { userName, email, passwordOne: password } = this.state;
    const { history } = this.props;
    auth
      .createUserWithEmailAndPassword(email, password)
      .then(authUser => {
        db.doCreateUser(authUser.uid, userName, email).then(() => {
          this.setState(() => ({ ...INITIAL_STATE }));
          history.push(routes.HOME);
        });
      })
      .catch(error => {
        this.setState({ error });
      });
  }

  render() {
    const { userName, email, passwordOne, passwordTwo, error } = this.state;
    const isValid =
      passwordOne === passwordTwo &&
      passwordOne !== '' &&
      email !== '' &&
      userName !== '';
    return (
      <Form onSubmit={this.onSubmit.bind(this)}>
        <FormGroup>
          <Input
            value={userName}
            placeholder="Username"
            onChange={({ target }) => this.setState({ userName: target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Input
            value={email}
            placeholder="Email"
            type="email"
            onChange={({ target }) => this.setState({ email: target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Input
            value={passwordOne}
            placeholder="Password"
            type="password"
            onChange={({ target }) =>
              this.setState({ passwordOne: target.value })
            }
          />
        </FormGroup>
        <FormGroup>
          <Input
            value={passwordTwo}
            placeholder="Confirm password"
            type="password"
            onChange={({ target }) =>
              this.setState({ passwordTwo: target.value })
            }
          />
        </FormGroup>
        <Button disabled={!isValid}>Sign up</Button>
        {error && <strong>{error.message}</strong>}
      </Form>
    );
  }
}

const SignUpLink = () => (
  <p>
    Don't Have an account?
    <Link to={routes.SIGN_UP}>Sign Up</Link>
  </p>
);
export default withRouter(SignUpPage);

export { SignUpLink, SignUpForm };
